export interface CsvData {
  columns: string[];
  rows: (string | number | boolean | null)[][];
}

/** Mirrors Papa Parse's `safe()` — escapes a cell value for CSV output. */
export function escapeCsvCell(value: string): string {
  const escaped = value.replace(/"/g, '""');
  const needsQuotes =
    escaped.includes(',') ||
    escaped.includes('"') ||
    escaped.includes('\r') ||
    escaped.includes('\n') ||
    escaped.includes('\uFEFF') ||
    escaped.charAt(0) === ' ' ||
    escaped.charAt(escaped.length - 1) === ' ';
  return needsQuotes ? `"${escaped}"` : escaped;
}

export function toCsvString({ columns, rows }: CsvData): string {
  const header = columns.map(escapeCsvCell).join(',');
  const body = rows
    .map((row) => row.map((cell) => escapeCsvCell(cell == null ? '' : String(cell))).join(','))
    .join('\n');
  return `${header}\n${body}`;
}

export function downloadAsCsv(data: CsvData, fileName: string): void {
  const csv = toCsvString(data);
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;
  a.click();
}
